export const phoneValidator = (phone: string): boolean => {
  const regex = /^\(\d{2}\) \d{5}-\d{4}$/;
  return regex.test(phone);
};
